import { render, staticRenderFns } from "./GradientLegend.vue?vue&type=template&id=1f692fa7&"
import script from "./GradientLegend.vue?vue&type=script&lang=js&"
export * from "./GradientLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports